import { IJSLComponent, IJSLVNode, refresh } from "jsl-render";
import { PublicController } from "../../ajax/PublicController";
import { FundDetailsDTO } from "../../ajax/types/FundDetailsDTO";
import { ImageGallerieComponent } from "../components/image-gallerie/ImageGallerieComponent";
import { LoadingComponent, date, FormFieldComponent, numeric } from "jsl-ui";
import { statusNames } from "../constants";
import { UserNameComponent } from "../components/UserNameComponent";
import { isInRole } from "../../helper/ajax";
import Axios from "axios";
import { CopyrightComponent } from "../components/CopyrightComponent";

export class FundComponent implements IJSLComponent {

    private data: FundDetailsDTO;
    private copyrightComp: CopyrightComponent;    
    private loading = false;
    
    constructor(private id: number){
        this.copyrightComp = new CopyrightComponent();
        PublicController.GetFund({ id }).then((data) => {
            this.data = data;
            refresh();
        });
    }

    public render(): IJSLVNode {
        if (this.data == null) {
            return <section class="banner-area">{new LoadingComponent()}</section>;
        }
        return <section class="banner-area">
            <div class="col-md-12" style="text-align:center">
                <div style="text-align:left;">
                    <a class="genric-btn primary" href="">zurück</a>
                </div>
                <h2>Fund [{this.data.fundId}]</h2>
                <br/>
                <div>Taxa: {this.data.name}</div>
                <div>Deutscher Name: {this.data.deutscherName}</div>
                <div>Langer Name: {this.data.langerName}</div>
                <div>Kurzer Name: {this.data.kurzerName}</div>
                <div>Gattung: {this.data.gattung}</div>
                <div>Familie: {this.data.familie}</div>
                <div>Gruppe: {this.data.gruppe}</div>
                <div>Epithet: {this.data.epithet}</div> 
                <br/>
                <h3>Zusatzinfos</h3>
                <div>Ökosystem: {this.data.oekosystem}</div>
                <div>Gefährdung: {this.data.gefaehrdungsStatus}</div>
                <div>Meereshöhe: {this.data.meerHoeheVon} - {this.data.meerHoeheBis}</div>
                <div>Klimatyp: {this.data.klimaTyp}</div>
                <div>Bodentyp: {this.data.bodenTyp}</div>
                <div>Bodensilikat Kalk: {this.data.bodenSilikatKalk}</div>
                <div>Region: {this.data.regionNaturraum?this.data.regionNaturraum:this.data.regionGebirgsraum}</div>
                <div>Lebensweise: {this.data.lebensweise}</div>
                <div>Datenquelle: {this.data.datenquelle}</div>
                <div>Jahresniederschlag [mm]: {this.data.jahresniederschlagInMM}</div>
                <div>Rote Liste - Bundesland: {this.data.roteListeBundesland}</div>
                <div>Rote Liste - Österreich: {this.data.roteListeOesterreich}</div>
                <br/>
                <h3>Fundort - Infos</h3>
                <div>Bundesland: {this.data.bundesland}</div>
                <div>Bezirk: {this.data.bezirk}</div>
                <div>Gemeinde: {this.data.gemeinde}</div>
                <div>Längen-/Breitengrad: {this.data.longitude}°/{this.data.latitude}°</div>
                <div>Beschreibung: {this.data.fundortBeschreibung}</div>
                <br/>
                <h3>Finder - Infos</h3>
                <div>Bestimmer: {this.data.bestimmer}</div>
                <div>Sammler: {this.data.sammler}</div>
                <div>Funddatum: {this.data.fundDatum.toLocaleDateString("de-DE", {day: "2-digit", year: "numeric", month: "long"})}</div>
                <div>Status: {statusNames[this.data.status]}</div>
                {this.data.freigabeKommentar ?
                    <p>Bemerkung: {this.data.freigabeKommentar}</p> : null}
                {this.data.freigegebenVon ?
                    <p>Geprüft von: {new UserNameComponent(this.data.freigegebenVon)}</p> : null}
                {this.data.freigegebenAm ?
                    <p>Geprüft am: {date.format(this.data.freigegebenAm)}</p> : null}                
                {/*<div>Untergattung: {this.data.unterGattung}</div>
                <div>Substrat Taxa: {this.data.substratTaxa}</div>*/}                               
                <br/>
                {new ImageGallerieComponent(this.data.images)}
                <br/>
            </div>
        </section>;
    }
}